import React, { Component } from 'react';
import styled from 'styled-components';

export default class LabelledTextInput extends Component {
  constructor(props) {
    super(props);

    this.focus = this.focus.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      edittable: false,
    };
  }

  focus() {
    this.refs.input.focus();
  }

  onSubmit(e) {
    if (e) e.preventDefault();

    this.setState({ edittable: false }, () => {
      this.props.onSubmit();
    });
  }

  render() {
    const display = !!this.props.value ? 'block' : 'none';
    const marginTop = !!this.props.value ? '20px' : '10px';

    return (
      <Container onClick={() => this.focus()}>
        <label htmlFor={this.props.name} style={{ display }}>{this.props.placeHolder}</label>
        <form onSubmit={this.onSubmit}>
          <input
            disabled={!this.state.edittable}
            ref="input"
            type={this.props.type}
            name={this.props.name}
            value={this.props.value}
            placeholder={this.props.placeHolder}
            style={Object.assign(this.props.style || {}, { marginTop })}
            onChange={this.state.edittable ? this.props.onChange : () => {}}
          />
        </form>
        <div
          style={{
            color: '#5d81ec',
            display: this.state.edittable ? 'none' : 'block',
            float: 'right',
            marginTop: 15,
            cursor: 'pointer',
          }}
          onClick={() => {
            this.setState({ edittable: true }, () => {
              this.focus();
            });
          }}
        >EDIT</div>
        <div
          style={{
            color: '#5d81ec',
            display: this.state.edittable ? 'block' : 'none',
            float: 'right',
            marginTop: 15,
            cursor: 'pointer',
          }}
          onClick={this.onSubmit}
        >SUBMIT</div>
      </Container>
    );
  }
}

const Container = styled.div`
  height: 70px;
  border: 2px solid #e5e5e5;
  border-radius: 0.25em;
  padding: 0.7em 1em;

  input {
    width: 800px;
    position: absolute;
    background: transparent;
    border: 0px;
    padding: 0px;
    font-family: 'Karla', sans-serif;
    z-index: 1;

    &::placeholder {
      opacity: 1;
      color: #a1aeb7;
    }
    &:focus {
      outline: none;
    }
  }

  label {
    position: absolute;
    color: #a1aeb7;
    font-size: 15px;
    margin-top: 2px;
    font-family: 'Karla', sans-serif;
  }
`;



// WEBPACK FOOTER //
// ./client/redesign/web/components/LabelledTextInputToggle/index.js